import { nodesForExclusion } from '@app/const';
import { Autocomplete, SwitchWrapper } from '@app/form_components';
import {
  ConfigView,
  ConfigViewType,
  DesignModule,
  DesignObject,
  IconClass,
  NodeType,
  NodeTypeName
} from '@app/types';
import { InputIcon } from '@platform/ui-library';
import { ChangeEvent } from 'react';
import BaseNodeModel from '../BaseNodeModel';

export default class WithFillerNodeModel extends BaseNodeModel {
  constructor(nodeName = 'WITH_FILLER_UNTITLED', x = 0, y = 0, props = null, id = null) {
    super(nodeName, x, y, null, id);
    this.props = {
      ...this.props,
      colorClass: 'brown',
      iconClass: IconClass.codepen,
      nodeTypeName: NodeTypeName.withFiller
    };
    this.DEFAULT_COLOR_CLASS = 'brown';
    this.applyProps(props);
  }

  onSearch(options: (DesignObject | DesignModule)[], search: string) {
    const filtered = (!search) ? options.filter(({ _class }) => {
      return _class === NodeType.module;
    }) : options.filter(({ id, name }) => {
      return name?.toLowerCase().includes(search.toLowerCase()) || id.toString().includes(search);
    });

    return filtered.slice(0, 30).map((component) => ({
      icon: component.props.iconClass,
      id: component.id,
      label: component.name!,
      value: component
    }));
  }

  getConfigViews() {
    const { modules, objects } = window.apm.serialized.components;
    const options = [...modules, ...objects].filter(({ _class, name }) => {
      return name && !nodesForExclusion.has(_class);
    }).sort((a, b) => {
      return a.name!.localeCompare(b.name!);
    });

    const referenceId = this.getConfig('referenceId');
    const referenceNodeTimeout = this.getConfig('referenceNodeTimeout');
    const referenceObject = options.find(({ id }) => id === referenceId);
    const isVerbalFiller = !!this.getConfig('isVerbalFiller');

    return [
      ...this.getConfigViewNameField(),
      {
        type: ConfigViewType.textarea,
        label: this.getPropLabel('description'),
        key: 'description',
        rows: 3
      },
      <>
        <hr />
        <div className="form-component-container">
          <Autocomplete
            getOptions={(search) => this.onSearch(options, search)}
            icon="search"
            initSearchValue={referenceObject?.name ?? ''}
            label="Linked Module or Object"
            labels={{ title: '' }}
            minSearchLength={0}
            onValueChange={({ _class, id }) => {
              this.setConfigAndParent('referenceId', id);
              this.setConfigAndParent('referenceNodeType', _class);
            }}
            placeholder="Search for a Module or Object"
            value={referenceObject}
          />
        </div>
        <div className="form-component-container">
          <InputIcon
            label="Timeout in Seconds"
            onChange={(e: ChangeEvent<HTMLInputElement>) => {
              this.setConfigAndParent('referenceNodeTimeout', e.target.value);
              document.dispatchEvent(new CustomEvent('ev-property-refresh'));
            }}
            placeholder="Maximum time to wait for the linked node to respond"
            value={referenceNodeTimeout}
          />
        </div>
        <div className="form-component-container">
          <SwitchWrapper
            defaultChecked={isVerbalFiller}
            inputFirst
            label="Add Verbal Filler"
            onChange={(e: ChangeEvent<HTMLInputElement>) => {
              this.setConfigAndParent('isVerbalFiller', e.target.checked);
              document.dispatchEvent(new CustomEvent('ev-property-refresh'));
            }}
            tooltip="When enabled typing filler and verbal filler will be played"
          />
        </div>
        <hr />
      </>,
      { type: ConfigViewType.textarea, label: this.getPropLabel('note'), key: 'note' }
    ] as ConfigView[];
  }
}
